import { useShoppingCartItemsV3 } from '~/domains/cart/queries';
import LegalNotice from '~/layouts/LegalNotice';

import OrderButton from '../OrderButton';
import Receipt from '../Receipt';

const CartOrderButton = () => {
  const { flatList, isLoading, isFetching } =
    useShoppingCartItemsV3('SHOPPING_CART');

  const checkedCount =
    flatList.filter(({ isSelected }) => isSelected).length || 0;

  return (
    <>
      <Receipt isSomeChecked={!!checkedCount} />
      <LegalNotice />
      <OrderButton
        isCartLoading={isLoading || isFetching}
        isSomeChecked={!!checkedCount}
      />
    </>
  );
};

export default CartOrderButton;
